import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from '../config/game';
import { birthdayConfig } from '../config/birthday';
import { AudioManager } from '../systems/AudioManager';
import { addSky } from './sceneArt';

export class StartScene extends Phaser.Scene {
  constructor() { super('StartScene'); }
  create(): void {
    addSky(this);
    this.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, GAME_WIDTH, GAME_HEIGHT, 0x172142, 0.3);
    this.add.text(195, 250, `WORLD ${birthdayConfig.age}-1`, { fontFamily: 'PixelFallback, monospace', fontSize: '31px', color: '#ffffff', stroke: '#172142', strokeThickness: 7 }).setOrigin(0.5);
    this.add.text(195, 302, 'GEBURTSTAGS-LEVEL', { fontFamily: 'PixelFallback, monospace', fontSize: '17px', color: '#ffd32a' }).setOrigin(0.5);
    const start = this.add.text(195, 415, 'START', { fontFamily: 'PixelFallback, monospace', fontSize: '32px', color: '#ffffff', backgroundColor: '#d94336', padding: { x: 24, y: 15 }, stroke: '#172142', strokeThickness: 4 }).setOrigin(0.5).setInteractive({ useHandCursor: true });
    this.add.text(195, 515, 'TIPPE, UM DAS ABENTEUER ZU BEGINNEN', { fontFamily: 'PixelFallback, monospace', fontSize: '10px', color: '#ffffff' }).setOrigin(0.5);
    this.tweens.add({ targets: start, scale: { from: 1, to: 1.06 }, yoyo: true, repeat: -1, duration: 650 });
    let started = false;
    const startLevel = () => {
      if (started) return;
      started = true;
      const audio = new AudioManager(this); audio.unlock(); audio.play('start');
      this.cameras.main.fadeOut(260, 23, 33, 66);
      // A timer is more reliable than the camera-complete event on mobile WebKit.
      this.time.delayedCall(280, () => this.scene.start('LevelScene'));
    };
    start.on('pointerdown', startLevel);
    this.input.keyboard?.once('keydown-SPACE', startLevel);
    this.input.keyboard?.once('keydown-ENTER', startLevel);
  }
}
